// Trips you have logged more than once, offered as one-tap "Log again" shortcuts.
export function frequentTrips(trips, limit = 4) {
  const map = {};
  (trips || []).forEach((t) => {
    if (!t.from && !t.to) return;
    const key = `${(t.from || "").toLowerCase()}|${(t.to || "").toLowerCase()}|${Math.round(t.distance * 10)}`;
    map[key] = map[key] || { from: t.from, to: t.to, distance: t.distance, purpose: t.purpose, clientId: t.clientId, count: 0 };
    map[key].count++;
  });
  return Object.values(map).filter((x) => x.count >= 2).sort((a, b) => b.count - a.count).slice(0, limit);
}
